import React from "react";
import ResponsiveImage from "@components/atoms/image/ResponsiveImage";

type DescriptionProps = {
  data: string[];
};

const Description = ({ data }: DescriptionProps) => {
  return (
    <>
      {data.map((item) => (
        <p
          className="lg:mt-3 md:mt-2 lg:maxw-md"
          dangerouslySetInnerHTML={{ __html: item }}
          key={item}
        />
      ))}
    </>
  );
};

const SvgWrapper = ({
  data,
  align,
}: {
  data?: string[];
  align: "left" | "right";
}) => {
  return (
    <div
      className={`svg-wrap ${
        align === "left" ? "svg-align-left" : "svg-align-right"
      }`}
    >
      {data?.map((svg) => (
        <div
          className="svg-item my-3"
          key={svg}
          dangerouslySetInnerHTML={{ __html: svg }}
        />
      ))}
    </div>
  );
};

type ImageData = {
  heading: string;
  desc: string[];
  cta: string;
  image: {
    adaptive: {
      path: string;
    };
    alt: string;
    align: "left" | "right";
  };
  isSvgPath?: boolean;
  svg?: string[];
};

type ImageComponentProps = {
  data: ImageData;
  className?: string;
};

const ImageComponent = ({ data, className }: ImageComponentProps) => {
  const { heading, desc, image, isSvgPath, svg } = data ?? {};
  const isImageLeft = image.align === "left";

  return (
    <div
      className={`grid--default has-align-middle md:mb-10 lg:mb-15 ${
        isImageLeft ? "" : "md:fx md:fx--w"
      } ${className || ""}`}
    >
      {isImageLeft && (
        <div className="pos-rel">
          <ResponsiveImage
            width="560"
            height="400"
            imgClass="img-fit md:w-100"
            src={image.adaptive.path}
            alt={image.alt}
            hasMobileImg={false}
          />
          {isSvgPath && <SvgWrapper data={svg} align="right" />}
        </div>
      )}

      <article
        className={`text-left ${isImageLeft ? "lg:maxw-md" : "fx--o-2"}`}
      >
        <h2
          className={`text-lg md:mt-5 md:mb-2 ${
            isImageLeft ? "lg:maxw-md" : ""
          }`}
        >
          {heading}
        </h2>
        <Description data={desc} />
      </article>

      {!isImageLeft && (
        <div className="pos-rel">
          {isSvgPath && <SvgWrapper data={svg} align="left" />}
          <ResponsiveImage
            width="560"
            height="400"
            imgClass="img-fit md:w-100"
            src={image.adaptive.path}
            alt={image.alt}
            hasMobileImg={false}
          />
        </div>
      )}
    </div>
  );
};

type FeaturedComponentProps = {
  data: ImageData[];
  className?: string;
};

const FeaturedComponent = ({ data, className }: FeaturedComponentProps) => {
  return (
    <>
      {data.map((item) => (
        <ImageComponent data={item} key={item.heading} className={className} />
      ))}
    </>
  );
};

export default FeaturedComponent;
